export const einsteinAPIConfig = {
    proxyPath: '/mobify/proxy/einstein',
    einsteinId: '',
    siteId: 'asics-us',
};
